import { Button } from '@/components/ui/button'
import Card from 'app/frontend/base/components/Card'
import { useTeamEventUpdateContext } from '../context/TeamEventUpdateContext'

type Props = {
  event: wowaudit.Event
  onImportClick: () => void
}

const EventGetStartedBanner = ({ event, onImportClick }: Props) => {
  const { updateEvent, setAllActivitiesActive } = useTeamEventUpdateContext()

  const planPerEncounter = () => {
    void updateEvent({ touched: true, raidsPlanningScope: 'per_encounter' })
  }

  const planSingleSetup = async () => {
    await updateEvent({ touched: true, raidsPlanningScope: 'single' })
    if (!event.activities.some((activity) => activity.active)) {
      await setAllActivitiesActive(true)
    }
  }

  return (
    <Card className='mt-6 flex max-sm:flex-col items-center justify-center w-full gap-6'>
      <h4 className='m-0'>Get started</h4>
      <div className='flex flex-wrap gap-2 max-sm:flex-col max-sm:*:w-full'>
        <Button type='button' onClick={onImportClick}>
          Import from previous event
        </Button>
        <Button
          type='button'
          variant='outline'
          onClick={() => void planSingleSetup()}
        >
          Plan single setup
        </Button>
        <Button type='button' variant='outline' onClick={planPerEncounter}>
          Plan per encounter
        </Button>
      </div>
    </Card>
  )
}

export default EventGetStartedBanner
